import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ImportantNoteComp from "./ImportantNoteComp";
import classes from "./OrderConfirmation.module.css";
import shared from "./OrderShared.module.css";
import { formatIsraeliNow } from "../utils/dateTime";

export default function OrderConfirmation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [orderDataProducts, setOrderDataProducts] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const allProducts = useSelector((state) => state.products.products);
  const currentOrderStore = useSelector((state) => state.cart.items);
  const submittingButton = React.useRef(null);
  const openningTime = "שעות פתיחה: ראשון - שישי: 05:30-15:00";

  useEffect(() => {
    if (!currentOrderStore || currentOrderStore.length === 0) {
      submittingButton.current.disabled = true;
      setOrderDataProducts(
        "לא נבחרו מוצרים להזמנה. יש לחזור לדף הקטגוריות ולהוסיף מוצרים.",
      );
    }
  }, [currentOrderStore]);

  useEffect(() => {
    const currentOrder = JSON.parse(localStorage.getItem("currentOrder"));
    const orderProducts = currentOrder.map((item) => {
      const productInfo = allProducts.find(
        (entry) => entry.id === item.productId,
      );
      if (!productInfo) {
        return { ...item };
      }

      const { id, ...productInfoWithoutId } = productInfo;

      return {
        ...productInfoWithoutId,
        ...item,
      };
    });
    setOrderDataProducts(orderProducts);

    const customerProfile = JSON.parse(localStorage.getItem("customerProfile"));
    setCustomerData({ ...customerProfile });
  }, [allProducts]);

  const handleSendRequest = async () => {
    setSubmitting(true);

    const updatedCustomerProfile = {
      ...customerData,
      orderedAt: formatIsraeliNow(),
    };
    const orderDataToSend = {
      customer: updatedCustomerProfile,
      products: orderDataProducts.map((item) => ({
        ...allProducts.find((product) => product.id === item.productId),
        quantity: item.quantity,
        ...(item.userCommentAnswer && {
          userCommentAnswer: item.userCommentAnswer,
        }),
      })),
    };

    try {
      localStorage.setItem(
        "customerProfile",
        JSON.stringify(updatedCustomerProfile),
      );

      // TODO: כאן תוכל לחבר את קריאת ה-API או כלי האוטומציה לשליחת מייל ו-WhatsApp
      await fetch(
        //Old API:

        // "https://hook.eu1.make.com/x16n2q1guu5cnllotuck7stodygtva20",

        //New API:
        "https://hook.eu1.make.com/kbecaigct1v8ecyhn5o3q9qyjhshz4fk",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(orderDataToSend),
        },
      );

      navigate("/orders/result", {
        state: {
          status: "success",
          currentOrder: orderDataProducts,
          customerProfile: updatedCustomerProfile,
        },
      });

      localStorage.removeItem("currentOrder");
      dispatch({ type: "cart/clearCart" });
    } catch (error) {
      console.error("Error sending order request:", error);
      navigate("/orders/result", {
        state: {
          status: "failure",
          currentOrder: orderDataProducts,
          customerProfile: customerData,
        },
      });
      setSubmitting(false);
    }
  };

  const handleBackToForm = () => {
    navigate("/orders/form");
  };

  const categoryNames = {
    flowers: "פרחים🌹",
    greenery: "ירוקים🌿",
    plants: "צמחים🪴",
    driedFlowers: "פרחים יבשים🌾",
    accessories: "אביזרים🎀",
    floralTools: "כלים פרחוניים✂️",
  };

  return (
    <bdo dir="rtl">
      <div
        className={`${classes.confirmationContainer} ${shared.orderPageContainer}`}
      >
        <section className={classes.successSection}>
          <div className={classes.successIcon}>📋</div>
          <h2 className={shared.pageTitle}>סקירת בקשת ההזמנה</h2>
          <p className={shared.pageSubtitle}>
            אנא בדוק את כל הפרטים למטה. אם הכל נראה בסדר, לחץ על "שלח בקשת
            הזמנה".
          </p>
        </section>
        <ImportantNoteComp
          style={{ maxWidth: "76rem", marginRight: "auto", marginLeft: "auto" }}
          caption={"ℹ️ מה צפוי לאחר השליחה:"}
          text={
            "לאחר קבלת הבקשה נבדוק זמינות במלאי וניצור איתך קשר טלפוני לאישור סופי. החיוב יתבצע רק לאחר אישורך, ולאחר מכן נתאם יחד מועד איסוף בהתאם לתאריך שביקשת בהזמנה."
          }
        />
        {/* פרטי לקוח - קריאה בלבד */}
        <section className={`${shared.sectionCard} ${classes.sectionNarrow}`}>
          <div
            className={`${shared.sectionTitle} ${classes.sectionTitleLarge}`}
          >
            👤 פרטי לקוח
          </div>
          <div className={classes.customerSummary}>
            <div className={shared.summaryRow}>
              <span
                className={`${shared.summaryLabel} ${classes.summaryLabelLarge}`}
              >
                שם מלא:
              </span>
              <strong
                className={`${shared.summaryValue} ${classes.summaryValueLarge}`}
              >
                {customerData.name || "---"}
              </strong>
            </div>
            {customerData.company && (
              <div className={shared.summaryRow}>
                <span
                  className={`${shared.summaryLabel} ${classes.summaryLabelLarge}`}
                >
                  חברה:
                </span>
                <strong
                  className={`${shared.summaryValue} ${classes.summaryValueLarge}`}
                >
                  {customerData.company}
                </strong>
              </div>
            )}
            <div className={shared.summaryRow}>
              <span
                className={`${shared.summaryLabel} ${classes.summaryLabelLarge}`}
              >
                אימייל:
              </span>
              <strong
                className={`${shared.summaryValue} ${classes.summaryValueLarge}`}
              >
                {customerData.email || "---"}
              </strong>
            </div>
            <div className={shared.summaryRow}>
              <span
                className={`${shared.summaryLabel} ${classes.summaryLabelLarge}`}
              >
                טלפון:
              </span>
              <strong
                className={`${shared.summaryValue} ${classes.summaryValueLarge}`}
              >
                {customerData.phone || "---"}
              </strong>
            </div>
          </div>
        </section>
        {/* מוצרים בהזמנה */}
        <section
          className={`${shared.sectionCard} ${classes.sectionNarrow} ${classes.productsSectionLarge}`}
        >
          <div
            className={`${shared.sectionTitle} ${classes.sectionTitleLarge}`}
          >
            🛒 מוצרים בהזמנה
          </div>
          <div className={classes.productsList}>
            {Array.isArray(orderDataProducts) &&
              orderDataProducts.map((item) => (
                <div key={item.productId} className={classes.productItem}>
                  <div className={classes.productInfo}>
                    <div className={classes.productName}>{item.name}</div>
                    <div className={classes.productCategory}>
                      {categoryNames[item.category]}
                    </div>
                    <div className={classes.productQuantity}>
                      כמות: {item.quantity}
                    </div>
                    {item.userCommentAnswer && (
                      <div className={classes.productComment}>
                        הערה: {item.userCommentAnswer}
                      </div>
                    )}
                  </div>
                  {item.imageURL && (
                    <img
                      src={item.imageURL}
                      alt={item.name}
                      className={classes.productImage}
                    />
                  )}
                </div>
              ))}
            {!Array.isArray(orderDataProducts) && (
              <div className={classes.noProductsMessage}>
                {orderDataProducts}
              </div>
            )}
          </div>
        </section>
        {/* מה לחכות */}
        <section
          className={`${shared.sectionCard} ${classes.sectionNarrow} ${classes.nextStepsSectionLarge}`}
        >
          <div
            className={`${shared.sectionTitle} ${classes.sectionTitleLarge}`}
          >
            ✅ מה צפוי בהמשך
          </div>

          <ul className={classes.nextStepsList}>
            <li className={classes.nextStepItem}>
              <span className={classes.stepIcon}>⏳</span>
              <strong>בדיקת זמינות:</strong> אנחנו נבדוק את זמינות המוצרים
              במחסן.
            </li>

            <li className={classes.nextStepItem}>
              <span className={classes.stepIcon}>📞</span>
              <strong>יצירת קשר:</strong> ניצור איתך קשר טלפוני לאישור סופי של
              ההזמנה, ולאחר האישור ממך יתבצע החיוב.
            </li>

            <li className={classes.nextStepItem}>
              <span className={classes.stepIcon}>📅</span>
              <strong>מועד האיסוף:</strong> איסוף ההזמנה יתבצע בהתאם לתאריך
              שביקשת, בכפוף לאישור סופי ביחד איתך.
            </li>

            <li className={classes.nextStepItem}>
              <span className={classes.stepIcon}>✅</span>
              <strong>איסוף עצמאי:</strong> אתה מגיע למחסן לאסוף את ההזמנה.
            </li>
          </ul>
        </section>
        {/* שיוצר קשר */}
        <section
          className={`${shared.sectionCard} ${classes.sectionNarrow} ${classes.contactSectionLarge}`}
        >
          <div
            className={`${shared.sectionTitle} ${classes.sectionTitleLarge}`}
          >
            📞 ליצירת קשר
          </div>

          <div className={classes.contactInfo}>
            {/* <div className={classes.contactItem}>
              <strong>אימייל:</strong>
              <a href="mailto:NestalFlowers@gmail.com">
                NestalFlowers@gmail.com
              </a>
            </div> */}
            <div className={classes.contactItem}>
              <strong>WhatsApp:</strong>
              {"  "}
              <a
                href="https://wa.me/+972505582265"
                target="_blank"
                rel="noreferrer"
                className={classes.contactLink}
              >
                לחץ כאן
              </a>
            </div>
            <div className={classes.contactItem}>
              <strong>טלפון:</strong>
              {"  "}
              <a href="tel:0505582265" className={classes.contactLink}>
                050-558-2265
              </a>
            </div>
            <div className={classes.contactItem}>
              <strong>{openningTime}</strong>
            </div>
          </div>
        </section>
        {/* כפתורים */}
        <div className={shared.actionButtons}>
          <button
            type="button"
            className={`${shared.buttonBase} ${shared.buttonPrimary}`}
            onClick={handleSendRequest}
            disabled={submitting}
            ref={submittingButton}
          >
            {submitting ? "שולח בקשה..." : "שלח בקשה"}
          </button>
          <button
            type="button"
            className={`${shared.buttonBase} ${shared.buttonSecondary}`}
            onClick={handleBackToForm}
          >
            ערוך פרטים
          </button>
          <button
            type="button"
            className={`${shared.buttonBase} ${shared.buttonSecondary}`}
            onClick={() => navigate("/orders")}
          >
            חזור לקטגוריות
          </button>
        </div>
      </div>
    </bdo>
  );
}
